import { defineStore } from 'pinia';
import axios from 'axios';

// Pinia replacement for the legacy Vuex FeatureFlags module.
//
// Exposes `featureFlagEnabled(flag)` (matches the old Vuex getter signature)
// and the `fetchFeatureFlags()` action that hydrates from localStorage first
// to keep the menu from flashing while the network call resolves.
export const useFeatureFlagsStore = defineStore('featureFlags', {
    state: () => ({
        flags: []
    }),
    getters: {
        featureFlagEnabled: state => flag => state.flags.includes(flag)
    },
    actions: {
        async fetchFeatureFlags() {
            const cached = localStorage.getItem('featureFlags');
            if (cached) {
                try {
                    this.flags = JSON.parse(cached);
                } catch {
                    localStorage.removeItem('featureFlags');
                }
            }
            const response = await axios.get('featureflags?client=Mosaic');
            this.flags = response.data;
            localStorage.setItem('featureFlags', JSON.stringify(response.data));
        }
    }
});
